"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.set = exports.get = undefined;

var _cookieHelper = require("../helpers/cookieHelper");

var cookieHelper = _interopRequireWildcard(_cookieHelper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var hasLocalStorage = false;
try {
  hasLocalStorage = window && window.localStorage;
} catch (err) {
  /* noop */
}

var get = exports.get = function get() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  var value = "";
  if (hasLocalStorage) {
    try {
      value = window.localStorage.getItem(key) || "";
    } catch (err) {
      value = cookieHelper.get(key);
    }
  }
  return value;
};

var set = exports.set = function set() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

  if (hasLocalStorage) {
    try {
      window.localStorage.setItem(key, value || "");
    } catch (err) {
      cookieHelper.set(key, value);
    }
  }
  return value;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-public/static-1.32/js/containers/tempStorage.js
// module id = 422
// module chunks = 0